<!-- @veltra/icons generated sha256:4a04ae7666ad8aba gen:8 source:src/svg/normal/form-file-picker.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormFilePicker' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="M1.5 3.5v9A1.5 1.5 0 0 0 3 14h10a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 13 3.5H8L6.5 2H3a1.5 1.5 0 0 0-1.5 1.5z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="M8 6.5V11M6 8.5l2-2 2 2"
    />
  </svg>
</template>
